import { Component, ElementRef, EventEmitter, Input, OnInit, Output, QueryList, viewChild, ViewChild, ViewChildren } from '@angular/core';

import { LayoutType } from 'src/app/model/enums/layout-type.enum';
import { SlideBuilderSection } from 'src/app/model/slide-builder-section';
import { SlideDTO } from 'src/app/model/slideDTO.model';
import { GeneralWidgetComponent } from '../general-widget/general-widget.component';
import { QuestionWidgetComponent } from '../question-widget/question-widget.component';
import { BackgroundSizeOption } from 'library-explorer';
import { SlideBuilderSectionBackgroundComponent } from '../slide-builder-section-background/slide-builder-section-background.component';

@Component({
    selector: 'app-slide-builder-section',
    templateUrl: './slide-builder-section.component.html',
    styleUrls: ['./slide-builder-section.component.scss'],
    standalone: false
})
export class SlideBuilderSectionComponent implements OnInit {
  public slideBackgroundComponent = viewChild(SlideBuilderSectionBackgroundComponent);

  @ViewChildren(GeneralWidgetComponent) public baseSlides: QueryList<GeneralWidgetComponent>;
  @ViewChildren(QuestionWidgetComponent) public questionBaseSlides: QueryList<QuestionWidgetComponent>;
  @ViewChild('leftColumn') public leftColumn: ElementRef;
  @ViewChild('rightColumn') public rightColumn: ElementRef;

  @Input() public section: SlideBuilderSection;
  @Input() public leftPosition = 0;
  @Input() public parentContainerHeight = 0;
  @Input() public chapterContainerHeight: number;
  @Input() public requiredToWatchVideo = false;
  @Input() public requiredToCompleteInteraction = false;
  @Input() public isFirstSection = false;
  @Input() public isLastSection = false;

  @Output() public answerChanged: EventEmitter<{ slide: SlideDTO, answer: any }> = new EventEmitter();
  @Output() public interactionCompleted: EventEmitter<{ slide: SlideDTO, completionRatio: number }> = new EventEmitter();
  @Output() public videoWatched: EventEmitter<SlideDTO> = new EventEmitter();
  
  public readonly layoutTypes: typeof LayoutType = LayoutType;
  public answer: any;

  public aspectRatio?: string;

  private readonly defaultColumnWidth = 50;

  private readonly DEFAULT_SPACING = 32;

  constructor(public readonly elementRef: ElementRef) { }

  ngOnInit() {
    this.setSlideColumnsWidth();
    this.setSlideColumnPaddings();
  }

  public backgroundMediaRatioChanged(ratio: string): void {
    this.aspectRatio = this.section?.backgroundSize === BackgroundSizeOption.FULL ? ratio : '';
  }

  public slideAnswerChanged(slide: SlideDTO, answer: any): void {
    this.answerChanged.emit( { slide, answer });
  }

  public emitVideoWatched(data: SlideDTO): void {
    this.videoWatched.emit(data);
  }

  public slideInteractionCompleted(data: { slide: SlideDTO, completionRatio: number }): void {
    this.interactionCompleted.emit(data);
  }

  private setSlideColumnsWidth(): void {
    const ratio = this.section.columnsRatio || 1;

    const columnWidth = this.defaultColumnWidth * ratio;
    this.elementRef.nativeElement.style.setProperty(`--lms-slide-left-column-width`, `${columnWidth}%`);
    this.elementRef.nativeElement.style.setProperty(`--lms-slide-right-column-width`, `${100 - columnWidth}%`);
  }

  private setSlideColumnPaddings(): void {
    if (!this.section?.spacing) {
      return;
    }
  
    const { spacing } = this.section;

    const sides = ['top', 'right', 'bottom', 'left'];

    sides.forEach(side => {
      const value = spacing?.[side] ?? this.DEFAULT_SPACING;
      this.elementRef.nativeElement.style.setProperty(`--lms-slide-row-padding-${side}`, `${value}px`);
    });
  }
}
